<script lang="ts">import { stateUi } from "@infinitro/config";
import { t, Verbiage } from "@infinitro/content";
import { loggedIn, toSiteUrl } from "@infinitro/global";
export let path;
export let verbiage;
let href;
$: {
	href = toSiteUrl(path, $loggedIn);
}
$: useAlternative = $stateUi.footer?.footerStyle === "alternative";
$: useAlternative4 = $stateUi.footer?.footerStyle === "alternative4";
</script>

<a {href} class="footer-link" class:alternative-footer-link={useAlternative || useAlternative4}>
	<span>{$t(verbiage)}</span>
</a>

<style>
	.footer-link {
		margin-bottom: 0.375rem;
		cursor: pointer;
		text-align: start;
		font-size: 0.75rem;
		line-height: 1rem;
		line-height: 16.8px;
		color: var(--color-text-300);
		font-family: var(--font-main)
}
	@media (min-width: 768px) {
		.footer-link {
				font-size: 0.875rem;
				line-height: 1.25rem
		}
	}
	.footer-link:hover {
		color: var(--color-text-100)
}
	.alternative-footer-link {
		color: var(--color-text-500)
}
	.footer-link:nth-child(even) {
		margin-top: 0.375rem /* This adds space between every even link */
}

	.footer-link:nth-child(odd) {
		margin-top: 0.375rem /* This adds space between every odd link */
}
</style>
